// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"23":"ba7e3709","139":"14741675","656":"a8eda337","749":"e622878c"}[chunkId] + ".chunk.css";
};